export function createContributorsDashboardFeature({ fetchContributors }) {
  const contributorList   = document.getElementById('contributorList');
  const contributorEmpty  = document.getElementById('contributorEmpty');
  const contributorsPanel = document.getElementById('dash-panel-contributors');

  async function load() {
    try {
      const rows = await fetchContributors();
      contributorList.innerHTML = '';
      contributorEmpty.hidden   = rows.length > 0;
      // Ordre de première contribution (cf. contributorService.js),
      // numéroté : 1 = le tout premier contributeur du projet.
      rows.forEach(({ pseudo }, index) => {
        const li = document.createElement('li');
        li.className = 'contributor-row';
        const rank = document.createElement('span');
        rank.className   = 'contributor-rank';
        rank.textContent = String(index + 1);
        li.append(rank, pseudo);
        contributorList.appendChild(li);
      });
    } catch (err) {
      console.error('Erreur chargement contributeurs:', err);
    }
  }

  // Ne recharge que si l'onglet est actuellement affiché : sinon, load()
  // (appelé au clic sur l'onglet) recalculera de toute façon l'état à jour.
  function refreshIfVisible() {
    if (!contributorsPanel.hidden) load();
  }

  return { load, refreshIfVisible };
}
